export var SurveyEvents;
(function (SurveyEvents) {
    SurveyEvents["onResponseUpdated"] = "onResponseUpdated";
    SurveyEvents["onContinue"] = "onContinue";
})(SurveyEvents || (SurveyEvents = {}));
export var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["ClosePage"] = "Close-page";
    ButtonTypes["Continue"] = "Continue";
    ButtonTypes["StartOver"] = "Start-over";
})(ButtonTypes || (ButtonTypes = {}));
export var ModalEvent;
(function (ModalEvent) {
    ModalEvent["Close"] = "CloseModal";
    ModalEvent["Open"] = "OpenModal";
    ModalEvent["Back"] = "popstate";
})(ModalEvent || (ModalEvent = {}));
export var VideoPlayerType;
(function (VideoPlayerType) {
    VideoPlayerType["Wistia"] = "Wistia";
    VideoPlayerType["YouTube"] = "Youtube";
    VideoPlayerType["Vimeo"] = "Vimeo";
})(VideoPlayerType || (VideoPlayerType = {}));
